import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from '@mui/stylis-plugin-rtl';

const readCspNonce = () => {
  if (typeof document === 'undefined') {
    return undefined;
  }

  const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content');

  return nonce || undefined;
};

const nonce = readCspNonce();

export const rtlCache = createCache({
  key: 'muirtl',
  nonce,
  stylisPlugins: [prefixer, rtlPlugin],
});

export const ltrCache = createCache({
  key: 'mui',
  nonce,
  stylisPlugins: [prefixer],
});
